<ng-template #exceptionPhrasesModal let-modal>
  <form [formGroup]="exceptionForm">
    <div class="modal-header">
      <h5 class="modal-title">
        {{
          'Settings::Privacy:Masking:PhraseType:Modal:Title'
            | abpLocalization: phraseType.displayName
        }}
      </h5>
      <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">
      <div class="field-row">
        <div class="field-label">
          {{ '::Language' | abpLocalization }}
          <span class="required">*</span>
        </div>
        <div class="field-content">
          <ng-select
            class="above-all"
            formControlName="languages"
            [items]="languagesDataSource"
            bindLabel="label"
            [multiple]="true"
            [closeOnSelect]="false"
            appendTo="body"
            (change)="onLanguagesChange($event)">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <input
                id="lang-opt-{{ index }}"
                type="checkbox"
                [ngModel]="item$.selected"
                [ngModelOptions]="{ standalone: true }" />
              {{ item.label }}
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div class="field-row last" *ngIf="phrasesArray.length > 0">
        <div class="field-label">
          {{ 'Settings::Privacy:Masking:PhraseType:Modal:ExecptionPhrases' | abpLocalization }}
          <i
            class="ms-2 fas fa-info-circle"
            [ngbTooltip]="
              'Settings::Privacy:Masking:PhraseType:Modal:ExecptionPhrases:Information'
                | abpLocalization
            "
            container="body"></i>
        </div>
        <div class="field-content">
          <div class="phrase-blocks" formArrayName="phrases">
            <div
              *ngFor="let group of phrasesArray.controls; let gi = index"
              class="phrase-block"
              [formGroupName]="gi">
              <div class="phrase-block-header">
                <i class="fas fa-language lang-icon"></i>
                <span class="lang-name">{{ group.get('languageLabel').value }}</span>
                <span class="count">
                  {{
                    'Settings::Privacy:Masking:PhraseType:Modal:PhraseCount'
                      | abpLocalization: getPhraseItems(gi).length.toString()
                  }}
                </span>
              </div>

              <div class="saved-list" *ngIf="getPhraseItems(gi).length > 0">
                <div class="saved-list-header">
                  <span>
                    {{ 'Settings::Privacy:Masking:PhraseType:Modal:Phrase' | abpLocalization }}
                  </span>
                </div>
                <div
                  *ngFor="let item of getPhraseItems(gi).controls; let ii = index"
                  class="saved-list-row">
                  <span class="phrase-text">{{ item.value }}</span>
                  <button class="remove-btn" type="button" (click)="removePhrase(gi, ii)">
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </div>
              </div>

              <div class="input-row">
                <ca-bulk-list-select
                  (itemsPasted)="onPhrasesPasted(gi, $event)"
                  class="flex-grow-1"
                  [cls]="'d-flex'">
                  <input
                    type="text"
                    formControlName="newPhrase"
                    [placeholder]="
                      'Settings::Privacy:Masking:PhraseType:Modal:Phrase:Placeholder'
                        | abpLocalization
                    "
                    (keydown)="onNewPhraseKeydown($event, gi)" />
                </ca-bulk-list-select>
                <button
                  class="ca-btn ca-btn-neutral add-btn"
                  type="button"
                  (click)="addPhrase(gi)"
                  aria-label="Add phrase">
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="hint">
            {{ 'Settings::Privacy:Masking:PhraseType:Modal:Information' | abpLocalization }}
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="ca-btn ca-btn-neutral" type="button" (click)="closeModal()">Cancel</button>
      <button
        class="ca-btn ca-btn-primary"
        type="button"
        (click)="onSet()"
        [ngbTooltip]="
          'Settings::Privacy:Masking:PhraseType:Modal:Set:Information' | abpLocalization
        ">
        <i class="far fa-cog"></i>
        {{ 'Settings::Privacy:Masking:PhraseType:Modal:Set' | abpLocalization }}
      </button>
    </div>
  </form>
</ng-template>
